export default {
  "meta": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NARS"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])}
  },
  "hero": {
    "loader": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("progress")), "%"])},
    "scroller": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scroll to Explore"])}
  },
  "stack": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A simple childhood in tarbes."])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["France is renowned for its rich cultural heritage and sense of aesthetics, and growing up in a small town in France has shaped François' artistic sensibility and authenticity."])}
  },
  "next": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next Chapter"])},
    "continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tap to continue"])}
  },
  "products": {
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View product page"])}
  },
  "carousel": {
    "slide": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slide to view"])},
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
    "learn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Learn more"])}
  },
  "text": {
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View more"])}
  },
  "chapter-1": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PASSATO. PRESENTE. NARS."])},
    "slice-0": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-0_image.png"])}
      }
    },
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["30 DI BELLEZZA RIVOLUZIONARIA"])},
      "youtube": {
        "desktop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2uKUUR6ZDqM"])},
        "mobile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["W5SCFeqkyxg"])}
      },
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-1_image.jpg"])}
      }
    },
    "slice-2": {
      "text": {
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Negli anni '90, François Nars ha ridefinito come indossare il make-up, nel backstage, sul set e nei magazine. Oggi, il suo approccio anticonformista alla bellezza continua ad alimentare la creatività, l’espressione di sé e un’arte senza limiti."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Mi piace trovare l’ispirazione nel passato, mi aiuta a progredire verso il futuro. Celebriamo 30 anni, ma anche un futuro in cui la bellezza continua a infrangere le regole.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["—François Nars, Fondatore e Direttore artistico"])}
      },
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-2_image-1.jpg"])}
      }
    },
    "slice-3": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UN'ICONA. IERI, OGGI E DOMANI."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["È iniziato tutto nel 1994 con 12 rossetti. 30 anni dopo, NARS festeggia questo importante anniversario puntando i riflettori sui prodotti iconici che aggiungono carattere e personalità illimitati alla tua routine."])},
      "item-1": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blush"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Colori cult per le guance."])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I blush migliori, da quasi trent’anni. Sin dal lancio di Orgasm nel 1999, François Nars non ha mai smesso di sostenere che il blush ricrea una sensazione, un sentimento. Il nostro prodotto iconico, ora disponibile in una formula potenziata, ti consente di esprimere il tuo umore e le tue emozioni con una gamma completa di colori per le guance. Facendoti risplendere ieri, oggi e domani."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Il blush non ha limiti. Siate audaci.” —François Nars, Fondatore e Direttore artistico"])},
        "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.it/it/blush/999NAC0000192.html"])},
        "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SCOPRI DI PIÙ"])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-1.jpg"])}
        }
      },
      "item-2": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Radiant Creamy Concealer"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Semplicemente, l’essenziale di ogni giorno."])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Progettato con le tecniche approvate dal nostro fondatore, questo correttore must-have ha riscosso un grande successo sin dal suo lancio. Illumina, correggi, perfeziona e celebra la nostra storia mentre crei la tua."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Correggendola senza mascherarla, la pelle appare più sana e più luminosa.” —François Nars, Fondatore e Direttore artistico"])},
        "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.it/it/radiant-creamy-concealer/999NACRCC0001.html"])},
        "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SCOPRI DI PIÙ"])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-2.jpg"])}
        }
      },
      "item-3": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Light Reflecting<sup>TM</sup> Foundation"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Una formula infusa di benefici skincare."])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La nostra formula vincente incapsula perfettamente la filosofia di François Nars: una pelle naturalmente luminosa, che risplende dall’interno. Questo fondotinta ibrido tra make-up e skincare sfuma istantaneamente le imperfezioni, migliorando visibilmente l’aspetto della pelle nel corso del tempo. Il primo passaggio per un make-up impeccabile, come dice François, è una bella pelle."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“La pelle migliore è una pelle in grado di riflettere la luce.” —François Nars, Fondatore e Direttore artistico"])},
        "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.it/it/light-reflecting-advanced-skincare-foundation/999NAC0000141.html"])},
        "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SCOPRI DI PIÙ"])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-3.jpg"])}
        }
      },
      "item-4": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Light Reflecting<sup>TM</sup> Setting Powder"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un finish luminoso, da sfoggiare davanti all’obiettivo."])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un classico cult che getta le basi per una pelle Light Reflecting™. Un visionario nel mondo della fotografia e dell’arte del make-up, François Nars sfrutta la luce come strumento per trasformare l’incarnato così che la pelle risulti perfetta sia di persona che davanti all’obiettivo. Brindiamo ad altri 30 anni di pelle radiosa dall’interno."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Mostrate sempre la pelle nella sua luce migliore.” —François Nars, Fondatore e Direttore artistico"])},
        "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.it/it/poudre-compacte-fixante-light-reflecting/999NAC0000099.html"])},
        "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SCOPRI DI PIÙ"])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-4.jpg"])}
        }
      },
      "item-5": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Explicit Lipstick"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un colore sulla cresta dell’onda."])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un colore sensazionale (e ricaricabile), il risultato di trent’anni di esperienza. La nuova punta di precisione scivola scorrevolmente sulla labbra per una raffinatezza scolpita in un solo gesto. Ispirato alla formula da cui ha avuto inizio tutto, ottimizzato per la generazione di oggi."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Per me il rossetto è sempre stato sinonimo di autostima. Brindiamo agli ultimi trent’anni di colori che rafforzano la personalità e ai prodotti Explicit del futuro.” —François Nars, Fondatore e Direttore artistico"])},
        "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.it/it/explicit-lipstick/999NAC0000221.html"])},
        "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SCOPRI DI PIÙ"])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-5.jpg"])}
        }
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UN POTERE VISIVO"])},
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dal 1996, François Nars ha fotografato personalmente numerose campagne NARS nel suo stile distintivo, caratterizzato da individualità, intuito e immaginazione audace. In quanto image-maker visionario, ha compreso sin da subito il potere dell’immagine, facendo sì che le sue opere contribuissero a superare i limiti degli standard di bellezza tradizionali."])},
      "item-1": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["INCARNATO"])},
        "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tra le prime campagne nella storia del marchio, questa immagine del 1997 era molto diversa dalle pubblicità di bellezza dell’epoca, e risulta ancora oggi moderna e senza tempo. Nonostante, di primo acchito, il rossetto audace possa sembrare al centro dell’attenzione, la pelle naturale e luminosa è altrettanto protagonista dell’immagine."])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-4_image-1.jpg"])},
          "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Complexion"])}
        }
      },
      "item-2": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ORGASM"])},
        "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niente rappresenta NARS quanto la campagna Primavera/Estate 1999 per il lancio di Orgasm. La tonalità trasformativa offre infinite possibilità puramente grazie al suo posizionamento: in questo caso, è applicata lievemente sul naso. Ciò che è oggi una tendenza virale del make-up, era una tecnica utilizzata da François già nel 1999."])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-4_image-2.jpg"])},
          "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Orgasm"])}
        }
      },
      "item-3": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LAGUNA"])},
        "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fotografata a Motu Tane, nella Polinesia francese, la campagna Autunno/Inverno 2003 mette in risalto l’iconica Laguna Bronzing Powder. L’intensità delle labbra rosse contro un viso perlopiù privo di make-up è equilibrata dal calore del bronzer, un componente lieve ma essenziale del look."])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-4_image-3.jpg"])},
          "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Laguna"])}
        }
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_next.jpg"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["François Nars"])}
    }
  },
  "chapter-2": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["François Nars"])},
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UN’EDUCAZIONE D’ISPIRAZIONE"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nato e cresciuto nel sud della Francia, François Nars ha trascorso l’infanzia studiando attentamente le riviste Vogue della madre e divorando classici del cinema europeo e di Hollywood. Guidato dalla sua passione per la bellezza e lo stile, ha frequentato la Scuola di Make-up Carita a Parigi."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-5.jpg"])}
      }
    },
    "slice-2": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LE PRIME MUSE, INTRAMONTABILI"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-2_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-2_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-2_image-3.jpg"])}
      }
    },
    "slice-3": {
      "text": {
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le prime fonti d’ispirazione creativa di François (nonché le più durature) sono state indubbiamente le donne della sua vita. La madre Claudette e le due nonne erano esempi audaci di muse e mentori, a dimostrazione di una forza di carattere incrollabile e del potere liberatorio dello stile personale."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Le mie icone di bellezza sono mia madre e le mie nonne, Garbo e Dietrich.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["—François Nars, Fondatore e Direttore artistico"])}
      },
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-3_image-1.jpg"])}
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["IMPRESE EDITORIALI"])},
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Incoraggiato da Polly Mellen, l’allora editrice della rivista americana <em>Vogue</em>, nel 1984 François si è trasferito a New York per lavorare nel settore del make-up editoriale. La sua carriera ha così subito un’impennata, plasmando nuovi standard di bellezza per le pagine di <em>Vogue</em>, <em>ELLE</em>, <em>Harper’s Bazaar</em>, e non solo."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-5.jpg"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-6.jpg"])}
      }
    },
    "slice-5": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UNA STAR DELLE PASSERELLE. <br/> UN SUCCESSO TRAVOLGENTE."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Portando il suo talento in passerella, François ha collaborato con stilisti come Karl Lagerfeld e Marc Jacobs. Nel 1994, ha lanciato una linea di 12 rossetti presso Barneys New York per soddisfare le proprie esigenze artistiche. Dal successo immediato del lancio, ha preso vita NARS Cosmetics."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-5.jpg"])}
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_next.jpg"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L’APPROCCIO DI NARS <br/>ALL’ARTE"])}
    }
  },
  "chapter-3": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L’APPROCCIO <br/> DI NARS <br/> ALL’ARTE"])},
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GLI INIZI DEL MARCHIO"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iconico. Individuale. Inaspettato—NARS. Nati dalla passione di François per il colore e la texture, i suoi 12 rossetti originali hanno ispirato una linea completa di cosmetici studiati per coccolare le donne con la sua visione della bellezza. Dopo trent’anni e innumerevoli prodotti, NARS continua a ispirare."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-4.jpg"])}
      }
    },
    "slice-2": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UNA BELLEZZA SENZA REGOLE"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un incarnato radioso. Uno sguardo smokey seducente. Labbra audaci. L’iconico look NARS si evolve continuamente, senza mai annoiare."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-5.jpg"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-6.jpg"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-7.jpg"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-8.jpg"])}
      },
      "image-9": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-9.jpg"])}
      },
      "image-10": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-10.jpg"])}
      }
    },
    "slice-3": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["THE MULTIPLE"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ispirato a un servizio fotografico del 1996 per Harper’s Bazaar, The Multiple si è affermato in quanto must-have di bellezza sin dalla sua creazione. Utilizzando un solo colore di rossetto per labbra, guance e occhi, François ha creato uno straordinario look monocromatico sulla top model Carolyn Murphy, dando il via al fenomeno di un’arte senza sforzo."])},
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-3_image-1.jpg"])}
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["IL VISO PRIMA DI TUTTO"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dalle tabelle dettagliate per il viso sino alle sue filosofie fondanti in materia di bellezza, François mette la stessa passione nel comunicare la propria visione quanto nel crearla."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-1.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["COLORE MONOCROMATICO"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La nostra interpretazione del look di make-up monocromatico virale, con un tocco di colore sulle guance e sul naso, labbra avvolte da un accento di rosa e occhi che brillano in sfumature rosate."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Con un colore delicato o intenso, non si sbaglia mai.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["—François Nars, Fondatore e Direttore artistico"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-2.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["IL POTERE DELLE TONALITÀ NEUTRE"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le tonalità neutre sono oggi più audaci che mai, con un blush applicato a forma di boomerang lungo le guance, occhi impreziositi da tonalità ramate e labbra in sfumature nude ispirate agli anni '90."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Le tonalità neutre consentono a tutti di vedere il tuo viso e la tua personalità così com’è, valorizzando la tua bellezza naturale.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["—François Nars, Fondatore e Direttore artistico"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-3.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LABBRA PIÙ INTENSE CHE MAI"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un rossetto matte audace è classico ed elegante, equilibrato qui da un inconfondibile sguardo NARS ben definito con un tocco smokey e guance scolpite in tonalità calde."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Un rossetto intenso potenzia sempre l’effetto del look.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["—François Nars, Fondatore e Direttore artistico"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-4.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UNA LUMINOSITÀ ETEREA"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Labbra delicate abbinate a uno sguardo lievemente definito, ispirato agli anni '60, danno vita a un look etereo, mentre l’abbinamento di tonalità calde e fredde sulle guance crea una luminosità onirica, come una seconda pelle."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Le labbra sono tenui ma intense, per un look di grandissimo effetto.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["—François Nars, Fondatore e Direttore artistico"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-5.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMOKEY FOREVER"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uno sguardo color prugna intenso unito a un rossetto ad alta lucentezza crea una versione trendy ma pur sempre sofisticata del classico smokey eye con un tocco di brillantezza."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Il make-up degli occhi permette la massima espressione della creatività rispetto agli altri cosmetici. Tutto sta nella sfumatura.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["—François Nars, Fondatore e Direttore artistico"])}
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_next.jpg"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UNA CARRIERA PROLIFICA"])}
    }
  },
  "chapter-4": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UNA CARRIERA <br/> PROLIFICA"])},
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<strong>François</strong> <strong>NARS: </strong><br/>\n<strong>DAGLI</strong> <strong>ARCHIVI</strong>"])},
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In quanto image-maker visionario, François ha sviluppato un ricco catalogo di opere fotografiche nel corso degli anni, culminato in un documentario sulla sua vita e i suoi successi."])}
    },
    "slice-2": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SCOPRI LA COLLEZIONE"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["X-RAY (1999)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>X-RAY</em> (1999)"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NARS 15x15 (2009)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em> NARS 15x15</em> (2009)"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND: EXPRESS YOURSELF - 2013"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>MAKEUP YOUR MIND:<br/>\nEXPRESS YOURSELF</em> (2013)"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["faery lands (2013)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>faery lands</em> (2013)"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FRANÇOIS NARS (2016)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>FRANÇOIS NARS</em> (2016)"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PERSONA (2021)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>PERSONA</em> (2021)"])}
      }
    },
    "slice-3": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["X-RAY"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1999"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Una collezione di ritratti eleganti e stilizzati di persone che hanno ispirato François con il loro stile inimitabile, tra cui Diane von Furstenberg, Carine Roitfeld, Boy George e tanti altri."])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["VEDI DI PIÙ"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GRACE JONES"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DIANE VON FURSTENBERG"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["CHRISTY TURLINGTON"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EARTHA KITT"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Carine Roitfeld"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Boy George"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-7.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Liza Minnelli"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-8.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manolo Blahnik"])}
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NARS 15X15"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2009"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un libro in edizione limitata di ritratti di celebrità ispirati ai nomi delle tonalità iconiche di NARS per commemorare il 15° anniversario di NARS Cosmetics."])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["VEDI DI PIÙ"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MARC JACOBS"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NAOMI CAMPBELL"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AMBER VALLETA"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DAYLE HADDON"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["daphne guinness"])}
      }
    },
    "slice-5": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND: EXPRESS YOURSELF"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2013"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un manuale di bellezza che offre tecniche di make-up avanzate, istruzioni precise e ritratti “prima” e “dopo” più vividi che mai."])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.com/USA/makeup-your-mind%3A-express-yourself/0607845032045.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["VEDI DI PIÙ"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2013)"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2013)"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2013)"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2013)"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2013)"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2013)"])}
      }
    },
    "slice-6": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2013"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un’ipnotica collezione fotografica di Motu Tane, l’isola privata in Polinesia francese che fornisce a François una fonte d’ispirazione illimitata con i suoi paesaggi, i suoi abitanti e la sua cultura."])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["VEDI DI PIÙ"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 1"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 2"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 3"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 4"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 5"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 6"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-7.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 7"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-8.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 8"])}
      },
      "image-9": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-9.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 9"])}
      },
      "image-10": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-10.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 10"])}
      },
      "image-11": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-11.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 11"])}
      }
    },
    "slice-7": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["François NARS"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2016"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Una biografia fotografica intrigante che narra la storia affascinante di François Nars, la sua visione ribelle e il suo mondo di una rara bellezza."])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["VEDI DI PIÙ"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      }
    },
    "slice-8": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persona"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2021"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un libro in edizione limitata in cui sono raccolti ritratti eclettici di figure creative di ogni età fotografate da François Nars."])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.com/USA/persona-book/0194251071077.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["VEDI DI PIÙ"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      }
    },
    "slice-9": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<strong>Unknown Beauty: <br/>François Nars</strong>"])},
      "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DIRETTO DA LISA IMMORDINO VREELAND"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 1"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 2"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 3"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 4"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 5"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 6"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-7.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 7"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-8.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 8"])}
      },
      "image-9": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-9.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 9"])}
      },
      "image-10": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-10.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 10"])}
      }
    },
    "slice-10": {
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un documentario in versione integrale che offre uno scorcio raro della vita del Fondatore e Direttore artistico, François Nars, e delle fonti d’ispirazione durature che alimentano la sua arte sin dall’infanzia."])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.amazon.com/Beauty-Fran%C3%A7ois-Nars-Charlotte-Rampling/dp/B0C9VQMC8S"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GUARDA ORA"])}
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_next_image.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["THE NARS ICONS"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LE ICONE NARS"])}
    }
  },
  "chapter-5": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LE ICONE NARS"])},
    "slice-0": {
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scopri le icone NARS che fanno scatenare l’artista che c’è in te, tutte concepite per aggiungere carattere e personalità illimitati alla tua routine. Per superare ogni limite ieri, oggi e per sempre."])}
    },
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Light Reflecting<sup>TM</sup> Setting Powder"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La cipria, il classico cult istantaneo firmato NARS che getta le basi per una pelle Light Reflecting<sup>TM</sup>."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La formula “no-flashback” fissa il look con un finish pronto per essere fotografato, con Tecnologia Fotocromatica che diffonde la luce e si adatta alle varie fonti luminose per una pelle perfetta sia di persona che davanti all’obiettivo. Non spegnere mai la tua luce interiore."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.it/it/poudre-compacte-fixante-light-reflecting/999NAC0000099.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACQUISTA ORA"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-4.jpg"])}
        }
      },
      "image-5": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-5.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-5.jpg"])}
        }
      }
    },
    "slice-2": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blush"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Our cult-favorite cheek color, now available in an upgraded formula, pops, sculpts, and highlights for up to 16 hours of silky, weightless wear."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pure Pigment Blend achieves true-color payoff with an innovative combination of four blendable pigments that make an impact while helping to blur the look of imperfections."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.it/it/blush/999NAC0000192.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACQUISTA ORA"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-4.jpg"])}
        }
      }
    },
    "slice-3": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Explicit lipstick"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ti presentiamo la nuova icona del lusso sostenibile."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il rossetto ricaricabile con punta di precisione scivola sulle labbra per una raffinatezza scolpita in un solo gesto, mentre il Complesso Luxe Comfort con Olio di Semi di Rosa Mosqueta e Acido Ialuronico avvolge le labbra per una coprenza cremosa e leggera da media a completa. Il colore classico si fonde a un carattere inaspettato per esaltare e provocare, offrendo un’eleganza con una marcia in più."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.it/it/explicit-lipstick/999NAC0000221.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACQUISTA ORA"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-4.jpg"])}
        }
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Light Reflecting<sup>TM</sup> Foundation"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spesso imitata ma mai replicata, la nostra formula vincente è imbattibile in quanto a luminosità."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Questo fondotinta ibrido tra make-up e skincare sfuma istantaneamente le imperfezioni e leviga la texture dell’incarnato, migliorando visibilmente l’aspetto della pelle nel corso del tempo. La coprenza media e modulabile, con una tenuta che dura tutto il giorno, garantisce che la pelle sia valorizzata e mai coperta."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.it/it/light-reflecting-advanced-skincare-foundation/999NAC0000141.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACQUISTA ORA"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-4.jpg"])}
        }
      }
    },
    "slice-5": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Radiant Creamy Concealer"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amato sia dai make-up artist che dal grande pubblico, questo must-have multifunzione è apprezzato per il suo utilizzo quotidiano più semplice che mai."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Una texture ultra-lussuosa infusa con l’inimitabile Multi-Active Botanical Blend offre un finish luminoso che aiuta la pelle a preservare la sua idratazione vitale per 24 ore. Le polveri esclusive contribuiscono a uniformare il tono della pelle e a sfumare l’aspetto delle imperfezioni fino a 16 ore di tenuta in 30 tonalità adatte a ogni carnagione. Illumina, correggi e perfeziona."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.it/it/radiant-creamy-concealer/999NACRCC0001.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACQUISTA ORA"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-4.jpg"])}
        }
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_next.jpg"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PASSATO. PRESENTE. NARS."])}
    }
  },
  "blocker": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PLEASE ROTATE <br/>YOUR SCREEN"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AVAILABLE ONLY IN PORTRAIT MODE"])}
  }
}